
import Cookie from 'js-cookie';

const setWindowCookie = () => {
  const name = 'vw=';
  let value;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      value = parseInt(c.substring(name.length, c.length), 10);
    }
  }
  if (value !== $(window).width()) {
    document.cookie = `vw=${$(window).width()};path=/`;
    document.cookie = `vh=${$(window).height()};path=/`;
  }
};

$.setCookie = (key, expiry) => {
  if (key && key.length > 0) {
    if (expiry && expiry <= '0') {
      expiry = 30;
    }
    Cookie.set(key, 1, { expires: expiry });
  }
};

$.getCookie = (key) => {
  if (key && key.length > 0) {
    return Cookie.get(key);
  }
};

$.removeCookie = (key) => {
  if (key && key.length > 0) {
    Cookie.remove(key);
  }
};

export default setWindowCookie;
